import React, { useEffect, useRef, useState } from "react";
import python_img from "../../../assets/images/python_img.jpg";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../config/https";
import { useParams } from "react-router-dom";
import { Loader } from "react-overlay-loader";
import { FaClock, FaTimesCircle, FaWifi } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { MdOutlineSkipNext, MdOutlineSkipPrevious } from "react-icons/md";
// import python_video from "../../../assets/images/python_video.mp4";

function CoursesVideoPage() {
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [lectures, setLectures] = useState([]);

  // const player = useRef(null);
  const videoRef = useRef(null);
  const [duration, setDuration] = useState(0);
  const [watchTime, setWatchTime] = useState(0);
  const [progress, setProgress] = useState(0);
  const [activeLecture, setActiveLecture] = useState({});
  const [activeLectureIndex, setActiveLectureIndex] = useState(0);
  console.log("activeLecture", activeLecture);

  useEffect(() => {
    const getLectures = () => {
      setLoader(true);
      axiosInstance.get(`/api/courses/${id}/videos/`).then((resp) => {
        setLoader(false);
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          setLectures(Data);
          setActiveLecture(Data[0]);
        } else {
          toast.warning(Data.msg);
        }
      });
    };

    getLectures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLoadedMetadata = () => {
    // Access the duration property of the video element
    const videoDuration = videoRef.current.duration;
    setDuration(videoDuration);
  };

  const handleTimeUpdate = (event) => {
    // The currentTime property of the event contains the current time of the video in seconds
    const currentTime = event.target.currentTime;
    setWatchTime(currentTime);
  };

  const calculateProgress = () => {
    return (watchTime / duration) * 100;
  };

  useEffect(() => {
    setProgress(calculateProgress());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchTime, duration]);

  useEffect(() => {
    if (progress === 100 && !activeLecture.watched) {
      axiosInstance
        .post(`/api/videos/${activeLecture.id}/mark-as-watched/`)
        .then((resp) => {
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setActiveLecture({ ...activeLecture, watched: true });
            toast.success("Successfully Watched!");
          } else {
            toast.warning(Data.detail);
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progress]);

  const handlePrev = () => {
    if (activeLectureIndex > 0) {
      setActiveLecture(lectures[activeLectureIndex - 1]);
      setActiveLectureIndex(activeLectureIndex - 1);
    }
  };

  const handleNext = () => {
    if (activeLectureIndex < lectures.length) {
      setActiveLecture(lectures[activeLectureIndex + 1]);
      setActiveLectureIndex(activeLectureIndex + 1);
    }
  };

  return (
    <div>
      {loader ? <Loader fullPage loading /> : null}
      <div className="course-sec pc-p-3">
        <div className="container-fluid px-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="course-video-box">
                <div className="course-img">
                  {lectures.length > 0 && (
                    <div>
                      <video
                        ref={videoRef}
                        controls
                        onLoadedMetadata={handleLoadedMetadata}
                        onTimeUpdate={handleTimeUpdate}
                      >
                        <source src={activeLecture.file} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                </div>
                <div className="course-box-content">
                  {/* <h5>Technology</h5> */}
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">
                      <a href="javascript:void(0)">{activeLecture?.title}</a>
                    </h4>
                    {activeLecture.watched ? (
                      <h4 className="mb-0">
                        <a>
                          <FaCircleCheck color={"green"} /> watched
                        </a>
                      </h4>
                    ) : (
                      <h4 className="mb-0">
                        <a>
                          <FaTimesCircle color={"red"} /> not watched
                        </a>
                      </h4>
                    )}
                  </div>
                  <div className="course-hour-box">
                    <span>
                      <FaClock /> {duration.toFixed(2)} Seconds
                    </span>
                    <span>
                      <FaWifi /> {activeLecture?.course?.level}
                    </span>
                  </div>
                </div>
                <div className="row p-2">
                  <div className="col-md-12 d-flex justify-content-between">
                    <button
                      className="primary-btn secondary-bg mx-1"
                      onClick={handlePrev}
                      disabled={activeLectureIndex === 0}
                    >
                      <MdOutlineSkipPrevious size={25} /> Previous
                    </button>
                    <button
                      className="primary-btn secondary-bg mx-1"
                      onClick={handleNext}
                      disabled={activeLectureIndex === lectures.length - 1}
                    >
                      Next <MdOutlineSkipNext size={25} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="course-sidebox">
                <div className="course-img mb-2">
                  <img src={python_img} alt="python" />
                </div>
                <div className="course-progress px-2 mb-2">
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${progress}%`,
                        ariaValuenow: progress,
                        ariaValuemin: 0,
                        ariaValuemax: 100,
                      }}
                    >
                      {progress.toFixed(1)}%
                    </div>
                  </div>
                  <div className="course-sidebox-content primary-heading color-dark mt-2">
                    <ul>
                      <li>
                        Duration: <span> {duration.toFixed(2)} Seconds </span>
                      </li>
                    </ul>
                    <h5>{activeLecture?.title}</h5>
                    <p>{activeLecture?.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row justify-content-center">
            {lectures.map((e) => (
              <div className="col-lg-2 col-md-3 col-12" key={e.id}>
                <div className="course-box">
                  <div className="course-img">
                    <img src={python_img} alt="Python" />
                  </div>
                  <div className="course-box-content">
                    <h4>
                      <a href="javascript:void(0)">{e.title}</a>
                    </h4>
                    <div className="course-hour-box">
                      <span>
                        <FaClock /> {e?.total_duration} Hour
                      </span>
                      <span>
                        <FaWifi /> {e?.level}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default CoursesVideoPage;
